module.exports = __webpack_public_path__ + "static/img/trees.2fd252c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trees.jpg
// module id = 876
// module chunks = 3